import { render, staticRenderFns } from "./ProfItem.vue?vue&type=template&id=035bbfdb&"
import script from "./ProfItem.vue?vue&type=script&lang=js&"
export * from "./ProfItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports